import {
    TASK_ACTION_ASYNC, TASK_ACTION_FINISHED,
    UPDATE_ONE_HANDLE_ONLY_FLAG,
    ADD_TO_ACTION_QUEUE,
    REMOVE_ACTION_FROM_QUEUE,
    LOOP_TASKS_FLAG,
    APPROVE_ACTION_RUNNING,
    APPROVE_ACTION_STOPED
} from '../../store/actionTypes';

import {approveMultipleShortcutKey} from '../myTasks.action';
import {DIRECT_TASK_ACTIONS, TASK_ACTIONS, TASK_DETAILS_BY_UID_URL_PART} from 'utils/constants';
import * as logger from 'utils/logger.function';
import {
    getUsersShowCommentOnApprove,
    getTasksForRender,
    forceApproveDialog,
    getTasksActionExtraData,
    getActiveTask,
} from "../../store/application.reducers";
import {approveMultipleTasks} from "./approveMultipleTasks.action";
import {taskDetailsPath} from "components/router/detailsPath";
import {checkForUnevaluatedLines} from "components/mytasks/action/taskDetailsCheck";

/**
 * redux actions dispatched to execute some task action
 */
export function taskAction(type, taskIds = [], options = {}) {

    return function (dispatch, getState) {

        const state = getState();
        const tasksData = getTasksActionExtraData(taskIds, state);
        const {
            navigate = () => {
            }
        } = options;

        if (type === DIRECT_TASK_ACTIONS.APPROVE_IMMEDIATELY) {
            const {comment, documentVersion, skipRestart, isFromBatch} = options;
            return dispatch(approveMultipleTasks(tasksData, comment, documentVersion, skipRestart, isFromBatch, navigate));
        }


        //all other actions need to display a dialog
        if (type !== TASK_ACTIONS.APPROVE && type !== TASK_ACTIONS.OPEN) {
            dispatch(taskActionAsync(type, taskIds, tasksData));
            return;
        }

        if (type === TASK_ACTIONS.APPROVE) {
            dispatch(handleApproveAction(state, taskIds, tasksData, options, navigate));
            return;
        }

        if (type === TASK_ACTIONS.OPEN) {
            const tasks = getTasksForRender(state); // beware, here it has immutable data

            dispatch(changeOneHandleOnlyFlag(false));

            let wantedId;
            // if none is selected, selected all
            if (taskIds.length === 0) {
                // dispatch(changeAllTaskSelection(true));
                dispatch(changeOneHandleOnlyFlag(true));
                wantedId = tasks.filteredKeys[0];
            } else {
                wantedId = taskIds[0];
            }

            // and navigate to the first task detail
            logger.debug("navigating to task with key:", wantedId);
            const wantedTask = tasks.filteredTasks.find(t => t.task.key === wantedId);
            // an edit can drop the open task from the list; fall back to it so the by-uid path is kept (AC-12800)
            const openTask = getActiveTask(state);
            const fallback = openTask?.key === wantedId ? openTask : {key: wantedId};
            // /tasks/<uid> is routable with fe-details-by-uid off, so stay on it rather than follow the flag
            const onOpenTaskByUid = fallback.uid && window.location.pathname === TASK_DETAILS_BY_UID_URL_PART + fallback.uid;
            if (!wantedTask && onOpenTaskByUid) {
                navigate(TASK_DETAILS_BY_UID_URL_PART + fallback.uid);
                return;
            }
            navigate(taskDetailsPath(wantedTask ? wantedTask.task : fallback));
            return;
        }
    }
}

function handleApproveAction(state, taskIds, tasksData, options, navigate) {

    return function (dispatch) {
        if (taskIds.length > 1 || getUsersShowCommentOnApprove(state) || forceApproveDialog(state)) {
            dispatch(taskActionAsync(TASK_ACTIONS.APPROVE, taskIds, tasksData));
            if (forceApproveDialog(state)) {
                dispatch(approveMultipleShortcutKey(false))
            }
            return;
        }

        //one task
        // the caller may know of a draft the list has not seen yet, e.g. one typed in the quick view
        let hasDraftComment = Boolean(options.hasDraftComment) ||
            Object.values(tasksData).findIndex(task => task.hsDraftComment) !== -1;
        if (hasDraftComment) {
            dispatch(taskActionAsync(TASK_ACTIONS.APPROVE, taskIds, tasksData));
            return;
        }
        const tasksWithAccountingGrid = Object.values(tasksData).filter(task => task.hasAccountingGrid);

        checkForUnevaluatedLines(tasksWithAccountingGrid).then((result) => {
            if (!result) {
                const {comment, documentVersion, skipRestart, isFromBatch} = options;
                return dispatch(approveMultipleTasks(tasksData, comment, documentVersion, skipRestart, isFromBatch, navigate));
            }
            dispatch(taskActionAsync(TASK_ACTIONS.APPROVE, taskIds, tasksData));
        });
    }
}


/**
 * sets the flag denoting if the user is in the iteration (eg he did 'handle all' action)
 * while in iteration we return user back to myTasks when the last task is handled .. otherwise we return upon first handle
 * @param oneHandleOnly
 */
export function changeOneHandleOnlyFlag(oneHandleOnly = false) {
    return {
        type: UPDATE_ONE_HANDLE_ONLY_FLAG,
        data: oneHandleOnly
    }
}

export function changeTryToLoopTasksFlag(loopTasks = false) {
    return {
        type: LOOP_TASKS_FLAG,
        data: loopTasks
    }
}

export function taskActionAsync(type, taskIds = [], tasksData = {}) {
    return {
        type: TASK_ACTION_ASYNC,
        actionType: type,
        taskIds: taskIds,
        tasksData: tasksData
    }
}

/**
 * async action finished, removed from the state all data for action
 * @return {{type}}
 */
export function actionFinished() {
    return {
        type: TASK_ACTION_FINISHED
    };
}

export function addActionToQueue(type, data) {
    return {
        type: ADD_TO_ACTION_QUEUE,
        data: {
            type: type,
            params: data
        }
    };
}

export function removeActionFromQueue(type) {
    return {
        type: REMOVE_ACTION_FROM_QUEUE,
        data: type
    };
}

export function approveActionRunning() {
    return {
        type: APPROVE_ACTION_RUNNING,
        data: TASK_ACTIONS.APPROVE
    };
}

export function approveActionStop() {
    return {
        type: APPROVE_ACTION_STOPED
    };
}

